export default __webpack_public_path__ + "static/media/circled-tick-white.7cef06cc.svg";